import WelcomePanelOptions from './WelcomePanelOptions'
import SubMenu from './SubMenu'

const WelcomePanel = () => (
    <SubMenu componentOptions={WelcomePanelOptions} />
)

export default WelcomePanel